var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPositivoNegativo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.99999C0 3.58172 3.58172 0 8 0H68.4997C72.918 0 76.4997 3.58172 76.4997 8V68.4997C76.4997 72.918 72.918 76.4997 68.4997 76.4997H7.99999C3.58172 76.4997 0 72.918 0 68.4997V7.99999Z",
    fill: "url(#paint0_linear_74_398)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_74_398",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 23,
    width: 32,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4831 31.2554L29.3306 26.4079C29.8381 25.8916 30.6606 25.8916 31.1768 26.3991C31.4918 26.7141 31.6231 27.1604 31.5356 27.5979L30.7043 31.6054H35.6481C37.5293 31.6054 38.7981 33.5304 38.0631 35.2629L35.2106 41.9216C34.9306 42.5604 34.3006 42.9804 33.6006 42.9804H25.7256C24.7631 42.9804 23.9756 42.1929 23.9756 41.2304V32.4891C23.9756 32.0254 24.1593 31.5791 24.4831 31.2554ZM22.2256 41.2304C22.2256 42.1929 21.4381 42.9804 20.4756 42.9804C19.5131 42.9804 18.7256 42.1929 18.7256 41.2304L18.7256 34.2304C18.7256 33.2679 19.5131 32.4804 20.4756 32.4804C21.4381 32.4804 22.2256 33.2679 22.2256 34.2304V41.2304Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5169 47.7446L47.6694 52.5921C47.1619 53.1084 46.3394 53.1084 45.8232 52.6009C45.5082 52.2859 45.3769 51.8396 45.4644 51.4021L46.2957 47.3946L41.3519 47.3946C39.4707 47.3946 38.2019 45.4696 38.9369 43.7371L41.7894 37.0784C42.0694 36.4396 42.6994 36.0196 43.3994 36.0196L51.2744 36.0196C52.2369 36.0196 53.0244 36.8071 53.0244 37.7696L53.0244 46.5109C53.0244 46.9746 52.8407 47.4209 52.5169 47.7446ZM54.7744 37.7696C54.7744 36.8071 55.5619 36.0196 56.5244 36.0196C57.4869 36.0196 58.2744 36.8071 58.2744 37.7696L58.2744 44.7696C58.2744 45.7321 57.4869 46.5196 56.5244 46.5196C55.5619 46.5196 54.7744 45.7321 54.7744 44.7696L54.7744 37.7696Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_74_398)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22.4997,
    width: 31.8118,
    height: 31.8118,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_74_398",
    x1: 38.2498,
    y1: 0,
    x2: 38.2498,
    y2: 76.4997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0021B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000E4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositivoNegativo);
export default __webpack_public_path__ + "static/media/PositivoNegativo.5d95493c2194a6823e0de80e6120532f.svg";
export { ForwardRef as ReactComponent };